export default __webpack_public_path__ + "static/media/global_solutions_modal_background.80faa0d9.png";